module.exports = __webpack_public_path__ + "img/scan.4fd1cce6.png";